import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
const readChoice = <T extends string,>(storageKey: string, valid: readonly T[], fallback: T): T => {
  if (typeof window === 'undefined') return fallback;
  try {
    const stored = window.localStorage.getItem(storageKey);
    return valid.includes(stored as T) ? stored as T : fallback;
  } catch {
    return fallback;
  }
};
export const usePersistedChoice = (storageKey, valid, fallback) => {
  const $ = _c(9);
  let t0;
  if ($[0] !== fallback || $[1] !== storageKey || $[2] !== valid) {
    t0 = () => readChoice(storageKey, valid, fallback);
    $[0] = fallback;
    $[1] = storageKey;
    $[2] = valid;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const [choice, _setChoice] = useState(t0);
  let t1;
  if ($[4] !== storageKey) {
    t1 = value => {
      _setChoice(value);
      try {
        window.localStorage.setItem(storageKey, value);
      } catch {}
    };
    $[4] = storageKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const setChoice = t1;
  let t2;
  if ($[6] !== choice || $[7] !== setChoice) {
    t2 = [choice, setChoice];
    $[6] = choice;
    $[7] = setChoice;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2 as const;
};